import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(buildAccountDetails),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(createAccount),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doInitializeAccountForm),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doSubmitAccountForm),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(watchAccountFormSagas);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import config from 'universal-config';
import * as logger from 'universal-logger';
import { initialize, SubmissionError } from 'redux-form';
import { createFormAction } from 'redux-form-saga';
import { all, call, fork, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { getUserLocation } from 'redux/saga/helpers';
import { friendbuyCode as getFriendbuyCode } from 'redux/saga/selectors/friendbuy';
import { selectUserLocale } from 'redux/modules/locale';
import { deepAssign, deepExtract } from 'helpers/deep';
import { ga } from 'helpers/multitrack';
import { getForApi as getUtmValues } from 'helpers/utmValues';
import { loadAccountCreationConsent, transformConsentForApi } from 'components/Consent/Consent.saga';
import { GENERIC_ERROR } from 'components/Errors/ApiError';
import { createUserAndLogIn } from 'features/Login/Authentication.saga';
import { postSignupTracking } from 'features/Signup/Signup.saga';
export var ACCOUNT_FORM = 'signup-card-account';
export var accountFormAction = createFormAction(ACCOUNT_FORM);
export var initializeAccountForm = function initializeAccountForm(hiddenFields) {
  return {
    type: "INITIALIZE_".concat(ACCOUNT_FORM),
    hiddenFields: hiddenFields
  };
};
export function buildAccountDetails(client, form) {
  var _ref, _ref2, activeLocation, consents, conversion, friendbuyCode, locale, user;

  return regeneratorRuntime.wrap(function buildAccountDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([call(getUserLocation, client), call(transformConsentForApi, form), call(getUtmValues), select(getFriendbuyCode), select(selectUserLocale)]);

        case 2:
          _ref = _context.sent;
          _ref2 = _slicedToArray(_ref, 5);
          activeLocation = _ref2[0];
          consents = _ref2[1];
          conversion = _ref2[2];
          friendbuyCode = _ref2[3];
          locale = _ref2[4];

          // Ensure RAF leads are correctly tracked
          if (friendbuyCode) {
            deepAssign('utm.utm_term', conversion, friendbuyCode);
          } // NOTE: changed through nav language selection


          user = {
            email: form.email,
            first_name: form.firstName,
            last_name: form.lastName,
            locale: locale
          };
          return _context.abrupt("return", {
            client_id: config().clientId,
            consents: consents,
            conversion: conversion,
            newsletter_subscribed: form.marketing,
            gls_location_id: deepExtract('location.id', activeLocation, null),
            user: user
          });

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function buildProduct(form) {
  var productKey = {
    offer: 'msa_offer_id',
    plan: 'plan_id'
  }[form.productType];
  return productKey ? _defineProperty({}, productKey, form.productId) : {};
}
export function createAccount(client, accountDetails, product) {
  return regeneratorRuntime.wrap(function createAccount$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(createUserAndLogIn, client, accountFormAction, _objectSpread({}, accountDetails, product));

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doInitializeAccountForm(client, _ref4) {
  var hiddenFields, consent;
  return regeneratorRuntime.wrap(function doInitializeAccountForm$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          hiddenFields = _ref4.hiddenFields;
          _context3.next = 3;
          return call(loadAccountCreationConsent, client);

        case 3:
          consent = _context3.sent;
          _context3.next = 6;
          return put(initialize(ACCOUNT_FORM, _objectSpread({}, consent, hiddenFields, {
            // NOTE: US-only overrides
            searchable: true,
            searchableDefault: true,
            searchableDisclaimer: '',
            terms: consent.accountDisclaimer
          })));

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function doSubmitAccountForm(client, _ref5) {
  var form, accountDetails, product, userId;
  return regeneratorRuntime.wrap(function doSubmitAccountForm$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          form = _ref5.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return call(buildAccountDetails, client, form);

        case 4:
          accountDetails = _context4.sent;
          _context4.next = 7;
          return call(buildProduct, form);

        case 7:
          product = _context4.sent;
          _context4.next = 10;
          return call(createAccount, client, accountDetails, product);

        case 10:
          userId = _context4.sent;
          _context4.next = 13;
          return call(postSignupTracking, 'email', accountDetails.user, userId);

        case 13:
          _context4.next = 15;
          return call(ga, 'Membership Purchase', 'Membership Purchase Account Creation');

        case 15:
          _context4.next = 17;
          return put(accountFormAction.success());

        case 17:
          _context4.next = 27;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 23;
          return call(ga, 'Membership Purchase', 'Membership Purchase Account Creation Error', 'Unknown Error');

        case 23:
          _context4.next = 25;
          return spawn(logger.error, deepExtract('message', _context4.t0, _context4.t0));

        case 25:
          _context4.next = 27;
          return put(accountFormAction.failure(new SubmissionError({
            _error: GENERIC_ERROR
          })));

        case 27:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 19]]);
}
export function watchAccountFormSagas(client) {
  return regeneratorRuntime.wrap(function watchAccountFormSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(takeEvery, initializeAccountForm().type, doInitializeAccountForm, client);

        case 2:
          _context5.next = 4;
          return fork(takeEvery, accountFormAction.REQUEST, doSubmitAccountForm, client);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}